<script setup lang="ts">
import type { ButtonProps } from '.';

import { Skeleton } from '../skeleton';
import { Primitive } from 'radix-vue';

import { cn } from '@/utils';
import { buttonVariants } from '.';

const props = withDefaults(defineProps<ButtonProps>(), {
	as: 'button',
	disabled: false
});
</script>

<template>
	<ClientOnly>
		<template #fallback>
			<Primitive
				:as="as"
				:as-child="asChild"
				:class="cn(buttonVariants({ variant, size }), props.class)"
				:disabled="disabled"
			>
				<slot></slot>
			</Primitive>
		</template>

		<Skeleton
			:is-active="props.isSkeletonLoading"
			:variant="props.skeletonVariant"
			:class="props.skeletonClasses"
		>
			<Primitive
				v-bind="$attrs"
				:as="as"
				:as-child="asChild"
				:class="cn(buttonVariants({ variant, size }), props.class)"
				:disabled="disabled"
			>
				<slot></slot>
			</Primitive>
		</Skeleton>
	</ClientOnly>
</template>
